import { postMessageToParent } from '../../utils/postMessageToParent';
export const postPlayEvent = combinedText => {
  postMessageToParent('external-api-event', {
    eventType: 'playButtonPlay',
    text: combinedText
  });
};
export const postPauseEvent = () => {
  postMessageToParent('external-api-event', {
    eventType: 'playButtonPause'
  });
};